<template>
  <div class="authGallery-wrap flex-col">
      <pageTitle :extinfo="extinfo"></pageTitle>
    <div class="gallery-bg">
      <img :src="galleryInfo.galleryHead+'?x-oss-process=image/resize,l_1212'" />
      <div class="masking"></div>
    </div>
    <div class="gallery-info">
      <img class="gallery-info-image" :src="galleryInfo.galleryHead+'?x-oss-process=image/resize,l_300'" />
      <div class="gallery-info-text">
        <div class="gallery-info-title">{{ galleryInfo.title }}</div>
        <div class="gallery-info-desc">展览时间：{{ galleryInfo.startDate }}-{{ galleryInfo.endDate }}</div>
        <div class="gallery-info-desc">
          媒体支持：
          <div class="media-itme" v-for="(app, index) in appList" :key="app.appId">
            <span v-if="index != 0">、</span>
            <div @click="toHref(app.indexUrl)">{{ app.tposApp.name }}</div>
          </div>
        </div>
      </div>
    </div>

      <div style="position: relative;">
      <div class="auth-min"></div>
      <div class="authGallery-info">
        <div class="section-title"><div class="left-line"></div>展览背景</div>
        <div class="authGallery-referral">
          <div class="user-update flex-row">
            <span id="user-update-txt" class="user-update-txt" :class="{'expend': !isExpend}">{{
              galleryInfo.description ? galleryInfo.description : ''
            }}</span>
          </div>
          </div>
        <div v-if="needExpend && !isExpend" @click="expendBrief(true)" class="opexpend">展开详情</div>
        <div v-if="needExpend && isExpend" @click="expendBrief(false)" class="opexpend">收起详情</div>
        <div class="section-title"><div class="left-line"></div>美术馆介绍</div>
        <art-gallery
        :galleryId="galleryId"
        :galleryCoverList="imgList"
        :galleryName="galleryInfo.title"
        :galleryDesc="galleryInfo.galleryDesc"
        @click="$router.push({name: 'unilty',query: {galleryId: galleryInfo.galleryId}})"></art-gallery>
      </div>
      <div class="works-box">
        <div class="works-title" ref="worksTitle" id="works-title" :class="{'works-fixed': worksFixed}">
          <div class="works-title-item" @click="current=0" :class="current == 0 ? 'active' : ''" >
            <div>参展作品<span>{{ worksList.length }}</span></div>
            <div class="under-line"></div>
          </div>
          <div class="works-title-item" @click="current=1" :class="current == 1 ? 'active' : ''">
            <div>参展艺术家<span>{{ artList.length }}</span></div>
            <div class="under-line"></div>
          </div>
        </div>
        <div style="height: 40px; width: 100%;" v-show="worksFixed"></div>
        <div class="user-works-box">
          <div class="works-list" v-show="current == 0">
            <template
                v-for="(item, index) in worksList">
              <works
                @prioimg="proImag"
                :item="item"
                :key="index"
              ></works>
            </template>
            <div v-if="worksList.length == 0" class="nowork">
              <van-image
                :src="require('@/assets/kong_zp.png')"
                width="140"
                height="128"
              ></van-image>
              <div class="noworktips">暂无作品</div>
            </div>
          </div>
          <div class="art-list" v-show="current == 1">
            <art-item :item="item" v-for="item in artList" :key="item.id" @click="toArtist">
          </art-item>
          </div>
        </div>
        <commen-list :commentList="commentList" :likeTotal="likeTotal" :commentTotal="commentTotal"></commen-list>
      </div>
    </div>
    <common-ct :likeCount="galleryInfo.likeCount" :commentCount="commentTotal" :extinfo="extinfo" @share="share" @common="common"
      @like="like"></common-ct>
    <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
  </div>
</template>

<script>
import { getGalleryInfo, getGalleryArtList, getGalleryWorkeList, getGalleryApp } from '@/api/gallery'
import { queryCommentLikeTotal, queryCommentList } from '@/api/artinfo'
import { getUrlParams, wexinShare, changeTitleClick } from '@/utils/utils'
import { queryShart } from '@/api/user'
import artItem from './components/artItem.vue'
import commonCt from '@/components/commonCt/commonCt.vue'
import commenList from '@/components/commenList/commenList.vue'
import artGallery from '@/components/artGallery/artGallery.vue'
import Works from '@/components/works/works.vue'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
export default {
  components: {
    Works,
    pageTitle,
    pageFoot,
    artGallery,
    artItem,
    commonCt,
    commenList
  },
  name: 'authGallery',
  data () {
    return {
      // 美术馆id
      galleryId: 0,
      // 美术馆数据
      galleryInfo: {
        description: ''
      },
      // 当前页数
      pageNo: 1,
      // 每页数量
      pageSize: 10,
      // 评论列表
      commentList: [],
      // 艺术家列表
      artList: [],
      // 作品列表
      worksList: [],
      // 第三方App列表
      appList: [],
      showBtn: true,
      extinfo: 'yslt://?name=authGallery&',
      code: '',
      needExpend: false,
      isExpend: true,
      imgList: [],
      commentTotal: 0,
      likeTotal: 0, // 点赞数
      current: 0,
      isSuspension: false,
      imageList: [],
      worksTop: 0,
      worksFixed: false
    }
  },
  computed: {
    sliceStr () {
      if (this.galleryInfo.description != null) {
        return this.galleryInfo.description.substring(0, 100) + '...'
      }
      return ''
    }
  },
  async created () {
    await this.getUrlParams()
    if (localStorage.getItem('code') === '' || localStorage.getItem('code') === 'undefined') {
      location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd195d7f108eab952&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=123&forcePopup=true#wechat_redirect`)
    }
    await this.getGalleryData()
    this.weixin()
    changeTitleClick(this.galleryInfo.title)
    this.extinfo = this.extinfo + `galleryId=${this.galleryId}`
    this.getCommonList()
    await this.queryCommentLikeTotal()
    this.getArtList()
    this.getWorkeList()
    this.getAppList()
    this.checkBrief()
  },
  mounted () {
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
    this.worksTop = document.getElementById('works-title').getBoundingClientRect().top + window.pageYOffset + 400
    console.log(this.worksTop)
  },
  updated () {
  },
  methods: {
    toArtist (id) {
      const url = `http://room.yslt.art/SharePageTest?onSharePage=0&userId=${id}`
      window.location.href = url
    },
    scrollHandle (e) {
      const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
      if (top > this.worksTop) {
        this.worksFixed = true
      } else {
        this.worksFixed = false
      }
    },
    // 预览图片
    proImag (img) {
      let position = 0
      this.worksList.forEach((item, index) => {
        if (item.id === img) {
          position = index
        }
      })
      this.ImagePreview({ images: this.imageList, startPosition: position })
    },
    async checkBrief () {
      const style = window.getComputedStyle(document.getElementById('user-update-txt'), null)
      const fontSize = style.fontSize
      const height = style.height.replace('px', '')
      const lineHeight = (style.lineHeight === 'normal' ? fontSize : style.lineHeight).replace('px', '')

      const line = height / lineHeight
      if (line > 5) {
        this.needExpend = true
        this.isExpend = false
      }
    },
    expendBrief (expend) {
      this.isExpend = expend
    },
    toHref (url) {
      window.location.href = url
    },
    // 获取美术馆详情函数
    async getGalleryData () {
      try {
        const res = await getGalleryInfo(this.galleryId)
        this.galleryInfo = res.result
        this.galleryInfo.startDate = this.galleryInfo.startDate.replaceAll('-', '.')
        this.galleryInfo.endDate = this.galleryInfo.endDate.replaceAll('-', '.')
        this.imgList = this.galleryInfo.galleryImg.split(',')
      } catch (error) {
        console.log('获取美术馆错误', error)
      }
    },
    // 获取url参数
    getUrlParams () {
      const params = getUrlParams()
      this.galleryId = params.id
      this.code = params.code || ''
      localStorage.setItem('code', params.code)
    },
    // 获取评论列表
    async getCommonList () {
      try {
        const res = await queryCommentList({
          topicId: this.galleryId,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        this.commentList = res.result.records
        this.commentTotal = res.result.total
      } catch (error) {
        console.log('评论数据列表失败', error)
      }
    },
    // 获取评论点赞
    async queryCommentLikeTotal () {
      try {
        const res = await queryCommentLikeTotal({
          topicId: this.galleryId
        })
        this.likeTotal = res.result.likeCount
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    // 获取参展艺术家列表
    async getArtList () {
      try {
        const res = await getGalleryArtList(this.galleryId)
        this.artList = res.result
      } catch (error) {
        console.log('获取艺术家列表失败', error)
      }
    },
    // 获取参展作品列表
    async getWorkeList () {
      try {
        const that = this
        const res = await getGalleryWorkeList(this.galleryId)
        this.worksList = res.result
        this.worksList.forEach((item, index) => {
          that.imageList[index] = item.coverUrl
        })
      } catch (error) {
        console.log('获取作品列表失败', error)
      }
    },
    // 获取App列表
    async getAppList () {
      try {
        const res = await getGalleryApp(this.galleryId)
        this.appList = res.result
      } catch (error) {
        console.log('获取App列表失败', error)
      }
    },
    // 打开云展厅方法
    openGallery (galleryId) {
      this.$router.push({
        name: 'unilty',
        query: {
          galleryId
        }
      })
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log(res)
      this.$nextTick(() => {
        wexinShare(res.result, {
          title: this.galleryInfo.title,
          desc: this.galleryInfo.brief,
          link: `http://room.yslt.art/share/?id=${this.galleryId}#/authGallery`,
          imgUrl: this.galleryInfo.shareCoverUrl
        })
      })
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    },
    share () {
      // this.open()
    },
    common () {
      // this.open()
    },
    like () {
      // this.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.openApp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.recommend-spec-title {
  justify-content: space-between;
  align-items: center;
  padding: 0 17px;
  margin-bottom: 20px;

  .recommend-spec-title-left {
    height: 25px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 9;

    span {
      z-index: 9999;
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      font-family: PingFang-SC-Bold;
    }

    .backgroun {
      position: absolute;
      bottom: 3px;
      left: 0;
      width: 72px;
      height: 8px;
      background: linear-gradient(90deg, #DCC0A3, #FFFFFF);
      border-radius: 4px;
    }

    >div {
      width: 3px;
      height: 18px;
      border-radius: 3px;
      background-color: #8E2912;
      margin-right: 6px;
    }
  }

  .recommend-spec-title-right {
    color: #727272;
    font-size: 14px;
    display: flex;
    align-items: center;
    position: relative;

    .image {
      width: 7px;
      height: 13px;
      margin-left: 4px;
    }
  }
}

.authGallery-wrap {
  overflow: hidden;
  padding-top: var(--status-bar-height);
  padding-bottom: 25px;
  background: #f2f2f2;

  .gallery-bg {
    height: 240px;
    position: relative;
    overflow: hidden;
  }

  .masking {
    position: absolute;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter:blur(6px);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%);
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    top: 0;
  }
.user-update-txt {
        white-space: pre-line;
        line-height: 1.8;
        font-size: 15px;
        color: #434343;
}
  .gallery-info {
    position: absolute;
    z-index: 99;
    top: 90px;
    padding: 0 20px;
    color: #fff;
    display: flex;
  }

  .gallery-info-image {
    height: 134px;
    width: 100px;
    border-radius: 12px;
  }

  .gallery-info-text {
    padding-top: 4px;
    margin-left: 20px;
  }

  .gallery-info-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .gallery-info-desc {
    margin-top: 16px;
    font-size: 12px;
  }

  .media-itme {
    display: inline-block;

    >div {
      display: inline-block;
      border-bottom: 1px solid #fff;
    }
  }

  .auth-min {
    height: 20px;
    width: 100%;
    border-radius: 16px 16px 0px 0px;
    background-color: #fff;
    position: absolute;
    top: -18px;
  }
  .section-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      padding: 30px 0 16px 0;
      .more {
       color: #999999;
       font-size: 13px;
       font-weight: 400;
       float: right;
       margin-top: 4px;

       img {
        height: 10px;
        width: auto;
        margin-left: 8px;
       }
      }

    }
.left-line {
    width: 2px;
    height: 14px;
    background: linear-gradient(0deg, rgba(248, 243, 234, 0.3) 0%, #BCA992 100%);
    margin-right: 8px;
    display: inline-block;
}
.expend {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        line-clamp: 5;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .opexpend {
        font-size: 14px;
        font-weight: 400;
        color: #A26F43;
        line-height: 1;
        margin-top: 5px;
      }

  .authGallery-info {
    background-color: #fff;
    padding: 0 17px;

    .authGallery-title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 32px;
    }

    .authGallery-time,
    .authGallery-media,
    .authGallery-referral {
      font-size: 12px;
      font-family: PingFang SC;
      color: #333;
      display: flex;
      justify-content: space-between;

      >div {
        flex: 1;
        font-size: 14px;
        font-family: PingFang SC;
        color: #727272;
      }
    }

    .authGallery-time {
      margin-bottom: 10px;
    }

    .authGallery-media {
      margin-bottom: 15px;
      align-items: center;

    }

    .banner-btn {
      height: 45px;
      text-align: center;
      line-height: 45px;
      font-size: 18px;
      color: #fff;
      background-color: #8E2912;
    }

    .authGallery-referral {
      margin-bottom: 7px;

      >div {
        margin-left: 0;
        font-size: 14px;
        font-family: PingFang SC;
        color: #727272;
        line-height: 22px;

        .tj {
          color: #727272;

          .btnWord {
            color: #B88653;
            float: right;
          }
        }
      }
    }
  }

  .story {
    padding: 20px 17px;
    background: linear-gradient(0deg, #FFFFFF, #FFFFFF, #F4EBE1);
  }

  .works-box {
    padding: 30px 0;
    background-color: #fff;
    position: relative;
    .works-fixed {
      top: 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      padding-top: 16px;
    }
    .works-title {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #F2F2F2;
      background: #fff;
      .works-title-item {
        font-size: 16px;
        color: #666;
        padding: 0 16px;
        text-align: center;
        div {
          font-size: 16px;
        }
        span {
          margin-left: 6px;
          font-size: 14px;
        }
        .under-line {
          height: 2px;
          width: 20px;
          background-color: #fff;
          border-radius: 2px;
          margin: 12px auto 0 auto;
        }
      }
      .active {
        color: #333;
        font-weight: bold;
        span {
          color: #333;
          font-weight: bold;
        }
        .under-line {
          background-color: #C4946B;
        }
      }
    }
  .user-works-box {
    margin-top: 6px;
    background-color: #fff;
    padding: 0 16px;
    margin-bottom: 16px;
    .works-list {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .art-list {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 20px;
    }
  }
  }

  .artist-box {
    padding: 17px 0;
    background-color: #fff;

    .recommend-spec-scroll {
      width: 100%;
      margin-top: 17px;
    }
  }

  .comment-box {
    padding: 0 18px 17px 18px;
    background-color: #fff;
    margin-top: 18px;

    .comment-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .right {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        flex: 1;
        position: relative;
        z-index: 99;

        .backgroun {
          position: absolute;
          bottom: 3px;
          left: 0;
          width: 72px;
          height: 8px;
          background: linear-gradient(90deg, #DCC0A3, #FFFFFF);
          border-radius: 8px;
          z-index: -1;
        }
      }

      .page-div,
      .like-conut {
        font-size: 14px;
        font-family: PingFang SC;
        color: #999999;
        margin-top: 30px;
      }

      .hx {
        width: 1px;
        height: 13px;
        background: #B8B8B8;
        margin: 0 10px;
      }
    }

    .uni-comment {
      .uni-comment-list {
        margin-top: 20px;
        padding-bottom: 20px;
        border-bottom: #f2f2f2 solid 1px;
      }
    }
  }

  .finde {
    width: 375px;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    z-index: 9;
    padding: 10px 17px 15px;
    border-top: 1px solid #f2f2f2;
    box-sizing: border-box;

  }
}
.artinfo-comment {
  padding: 0 17px;
}

.scrollX {
  overflow-x: scroll;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
